import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterArquivoPdfNoticiaState } from "../../reducers/BancoNoticias/obter-arquivo-pdf-noticia.reducer";

export const selectObterArquivoPdfNoticiaState = createFeatureSelector<ObterArquivoPdfNoticiaState>('obterArquivoPdfNoticia');

export const selectDadosObterArquivoPdfNoticia = createSelector(
  selectObterArquivoPdfNoticiaState,
  (state: ObterArquivoPdfNoticiaState) => state.response
);

export const selectObterArquivoPdfNoticia = createSelector(
  selectObterArquivoPdfNoticiaState,
  (state: ObterArquivoPdfNoticiaState) => state
);

export const selectErrosObterArquivoPdfNoticia = createSelector(
  selectObterArquivoPdfNoticiaState,
  (state: ObterArquivoPdfNoticiaState) => state.error
);
